import { render, staticRenderFns } from "./theme-bonus-description.vue?vue&type=template&id=3333be5f"
import script from "./theme-bonus-description.vue?vue&type=script&lang=js"
export * from "./theme-bonus-description.vue?vue&type=script&lang=js"
import style0 from "./theme-bonus-description.vue?vue&type=style&index=0&id=3333be5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports